import Swiper, { Manipulation, Navigation } from 'swiper';

/**
 * Featured Categories carousel with division filters.
 *
 * Filters behave like radios that can be cleared: one division at a time,
 * clicking the active filter again shows all slides.
 */
export default function FeaturedCategories(el, {
    carouselHandle,
    filterHandle,
}) {
    const carousel = el.querySelector(carouselHandle);
    const prev = el.querySelector('.swiper-button-prev');
    const next = el.querySelector('.swiper-button-next');
    const filters = Array.from(el.querySelectorAll(filterHandle));

    // Keep the original slides so filtering can rebuild the set in CMS order
    const slides = Array.from(carousel.querySelectorAll('.swiper-slide'))
        .map(slide => slide.cloneNode(true));

    const swiper = new Swiper(carousel, {
        modules: [Manipulation, Navigation],
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        speed: 600,
        slidesPerView: 1.25,
        spaceBetween: 24,
        watchOverflow: true,
        breakpoints: {
            768: {
                slidesPerView: 2.25,
                spaceBetween: 32,
            },
            992: {
                slidesPerView: 3.25,
                spaceBetween: 36,
            },
            1280: {
                slidesPerView: 4.25,
                spaceBetween: 36,
            },
        },
    });

    function applyFilter(division) {
        const visible = division
            ? slides.filter(slide => slide.dataset.division === division)
            : slides;

        swiper.removeAllSlides();
        swiper.appendSlide(visible.map(slide => slide.cloneNode(true)));
        swiper.update();
        swiper.slideTo(0, 0);
    }

    function handleFilterClick(e) {
        const button = e.currentTarget;
        const isActive = button.getAttribute('aria-pressed') === 'true';

        filters.forEach(f => f.setAttribute('aria-pressed', 'false'));

        if (isActive) {
            applyFilter(null);
        } else {
            button.setAttribute('aria-pressed', 'true');
            applyFilter(button.dataset.division);
        }
    }

    filters.forEach(f => f.addEventListener('click', handleFilterClick));
}
